import * as Spotlight from "@spotlightjs/spotlight";

// initialize spotlight on for development
if (process.env.NODE_ENV === "development") {
  Spotlight.init();
}

// import the main stylesheet
import "../scss/main.scss";

// import the complete bootstrap framework
import * as bootstrap from "bootstrap";

// import and register htmx to the window element
import htmx from "htmx.org";
window.htmx = htmx;

// HX-Boost does not update body attributes nor classes by default.
htmx.on("htmx:afterSwap", function (event) {
  const targetElement = event.detail.target;
  // workaround is only needed for the HTML BODY tag
  if (targetElement.tagName !== "BODY") {
    return;
  }
  // parse the response to get the new body attributes
  const parser = new DOMParser();
  const parsedResponse = parser.parseFromString(
    event.detail.xhr.response,
    "text/html",
  );
  const newBodyAttributes =
    parsedResponse.getElementsByTagName("body")[0].attributes;
  // remove all existing attributes from the current body
  Object.values(targetElement.attributes).forEach(({ name }) => {
    targetElement.removeAttribute(name);
  });
  // add all attributes from thy body element in the response
  for (const attribute of newBodyAttributes) {
    targetElement.setAttribute(attribute.name, attribute.value);
  }
});

htmx.on("htmx:afterSwap", function (event) {
  // re-bind the instant search component
  bindInstantSearch();
});

function bindInstantSearch() {
  let instantSearchInputs = document.getElementsByClassName(
    "instant-search-input",
  );
  Array.from(instantSearchInputs).forEach(function (instantSearchInput) {
    instantSearchInput.addEventListener("input", function () {
      const searchValue = instantSearchInput.value.trim().toLowerCase();
      const resultElements = document.querySelectorAll("[data-search-term]");
      Array.from(resultElements).forEach(function (element) {
        element.hidden = !(
          searchValue === "" ||
          element.dataset.searchTerm.toLowerCase().includes(searchValue)
        );
      });
    });
    instantSearchInput.addEventListener("keyup", (event) => {
      if (event.key === "Escape") {
        instantSearchInput.value = "";
        instantSearchInput.dispatchEvent(new Event("input", { bubbles: true }));
      }
    });
  });

  let clearInstantSearchInputs = document.getElementsByClassName(
    "clear-instant-search-input",
  );
  Array.from(clearInstantSearchInputs).forEach(function (clearSearch) {
    clearSearch.addEventListener("click", function () {
      let instantSearchInputs = document.getElementsByClassName(
        "instant-search-input",
      );
      Array.from(instantSearchInputs).forEach(function (instantSearchInput) {
        instantSearchInput.value = "";
        instantSearchInput.dispatchEvent(new Event("input", { bubbles: true }));
      });
    });
  });
}

// import and register Charts.js to the window element
import Chart from "chart.js/auto";
window.Chart = Chart;
